<template>
  <div class="top_card_stock_detail" v-if="stockInfo">
    <StockImageTag
      :imgUrl="stockInfo.logoUrl"
      @click.stop="goToStocksScreen(stockInfo.symbol, stockInfo.type)"
      :symbol="stockInfo.symbol"
      :toFixed="true"
      :market="stockInfo.type"
      :stockData="stockData"
      :stockId="stockInfo._id"
    />
    <p
      class="c-pointer stock-symbol-info"
      @click.exact.self.stop="
        goToStocksScreen(stockInfo.symbol, stockInfo.type)
      "
    >
      {{ stockInfo.symbol }}
      <span>{{ stockInfo.companyName }}</span>
    </p>

    <span
      v-if="stockData"
      class="stockId asdsad stockDetailsFlex"
      :class="{ 'create-view': isCreateView }"
    >
      <span
        class="price"
        v-html="$filters.systemNumberConvention(stockData.price, true)"
      ></span>
      <span
        class="price__tag"
        :class="
          stockData.changesPercentage >= 0 ||
          stockData.changesPercentage == 'n/a'
            ? 'positive'
            : 'negative'
        "
      >
        <i
          class="fas"
          :class="
            stockData.changesPercentage >= 0 ||
            stockData.changesPercentage == 'n/a'
              ? 'fa-caret-up'
              : 'fa-caret-down'
          "
        ></i>
        {{
          Math.abs(
            $filters.systemNumberConvention(stockData.changesPercentage)
          )
        }}%
      </span>
    </span>
  </div>

  <!-- <div class="top_card_stock_detail" v-else>
    <figure>
      <Skeletor />
    </figure>
    <p>
      <Skeletor />
      <span style="margin-top: 10px">
        <Skeletor />
      </span>
    </p>
  </div> -->
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref,
  watch,
} from "vue";
import utilService from "@/services/util.service";
import IconComponent from "@/components/IconComponent.vue";
import { StockMarkets } from "../../models/stocks.model";
import { useSocketStockData } from "@/composables/stock_data.composable";
import { useStockSocket } from "@/composables/stock_socket.composable";

export default defineComponent({
  components: {
    IconComponent,
  },
  props: {
    stockInfo: {
      type: Object,
    },
    showDuration: {
      type: Boolean,
      default: false,
    },
    isCreateView: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    let selectedFilter = ref("1d");
    const durations = ref(utilService.chartDuartions);

    const { addStockId, checkStockExistence } = useStockSocket();

    const initialObject = () => {
      let obj = {
        _id:
          props.stockInfo?.stockId ||
          props.stockInfo?.stock_id ||
          props.stockInfo?._id,
        symbol: props.stockInfo?.symbol,
        companyName: props.stockInfo?.companyName,
        last: props.stockInfo?.price || props.stockInfo?.last,
        change: props.stockInfo?.change,
        changePercent: props.stockInfo?.changePercent,
        market: props.stockInfo?.type,
      };
      if (
        !checkStockExistence(
          props.stockInfo?.stockId ||
            props.stockInfo?.stock_id ||
            props.stockInfo?._id
        )
      ) {
        addStockId({
          showTrendChart: true,
          stockId:
            props.stockInfo?.stockId ||
            props.stockInfo?.stock_id ||
            props.stockInfo?._id,
        });
      }
      return obj;
    };
    const { stockData, updateStockInfoObject } = useSocketStockData(
      initialObject()
    );

    watch(
      () => props.stockInfo,
      async (newStockData) => {
        updateStockInfoObject(initialObject());
        await nextTick(); // Ensure DOM updates immediately
      },
      { deep: true }
    );

    onMounted(() => {
      updateStockInfoObject(initialObject());
    });

    const getStockImage = (symbol: string, type: StockMarkets) =>
      utilService.getStockImage(symbol, type);

    const goToStocksScreen = (stockId: string, type: string) => {
      // utilService.goToStockScreen(stockId, type);
    };

    watch(selectedFilter, () => {
      context.emit("handleSelectedFilter", selectedFilter);
    });

    return {
      selectedFilter,
      durations,
      stockData,
      goToStocksScreen,
      getStockImage,
      initialObject,
    };
  },
});
</script>

<style scoped lang="scss">
.price__tag {
  color: var(--bullish-light4) !important;
  fill: var(--bullish-light4);
  i {
    color: var(--bullish-light4);
    fill: var(--bullish-light4);
  }
  &.negative {
    color: var(--color-negative) !important;
    fill: var(--color-negative);
    i {
      color: var(--color-negative);
      fill: var(--color-negative);
    }
  }
}
.top_card_stock_detail {
  display: flex;
  gap: 12px;

  .stock-symbol-info {
    overflow: hidden;
  }
  .stockDetailsFlex {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .price {
      color: var(--recommend-hold);
      font-size: var(--font-xl);
      font-weight: 600;
      line-height: 1;
    }
  }

  p {
    color: var(--base-text-white) !important;
    font-weight: 600 !important;

    span {
      color: var(--grey-color) !important;
    }
  }

  .stockId.create-view {
    padding-inline-end: 33px;
    padding-top: 3px;
  }
}

@media (min-width: 1280px) and (max-width: 1891px) {
  .top_card_stock_detail {
    gap: 8px;

    .stockDetailsFlex {
      .price {
        font-size: var(--font-sm) !important;
      }

      .price__tag {
        font-size: var(--font-2xs) !important;
      }
    }

    p {
      &:not(.price__tag) {
        font-size: var(--font-xs);

        span {
          font-size: var(--font-2xs) !important;
        }
      }
    }
  }
}
</style>
